import { JsonConvert } from 'json2typescript';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { HrConfigurationService } from 'humanresources-common-shared';
import { HvlPage, HvlPageable, HvlResponse } from '@hvlng/framework-bff/core';
import {
    OrganizationDefinitionQueryModel
} from '../personnel/organization/organization-picker/model/organization-definition-query-model';
import {
    OrganizationDefinitionModel
} from '../personnel/organization/organization-picker/model/organization-definition-model';
import { PerPersonnelModel } from '../personnel/personnel-operations/model/per-personnel-model';
import { PerPersonnelQueryModel } from '../personnel/personnel-operations/model/per-personnel-query-model';
import { PositionQueryModel } from '../personnel/organization/position-management/model/position-query-model';
import { PositionModel } from '../personnel/organization/position-management/model/position-model';
import {
    PerPersonnelSearchQueryModel
} from '../personnel/personnel-operations/model/hr-per-personnel-search-query-model';
import { PerPersonnelSearchModel } from '../personnel/personnel-operations/model/hr-per-personnel-search-model';

@Injectable({
    providedIn: 'root',
})
export class PersonnelSharedService
{
    endpoint: string;
    readonly serviceRootPattern = '/personnelSharedService/';
    private converter: JsonConvert;

    constructor(
        private httpClient: HttpClient,
        private configService: HrConfigurationService,
    ) {
        this.endpoint = configService.config.hr.personnel;
        this.converter = new JsonConvert()
    }



    public queryOrganizationPage(pagination: OrganizationDefinitionQueryModel): Observable<HvlPage<Array<OrganizationDefinitionModel>>> {
        if (!pagination.pageable) {
            pagination.pageable = new HvlPageable();
        }

        const pattern = this.serviceRootPattern + 'organizationPage';
        return this.httpClient
            .post<HvlResponse<HvlPage<OrganizationDefinitionModel[]>>>(this.endpoint + pattern, pagination)
            .pipe(
                map((hvlpage) => {
                    const data = hvlpage.body?.totalElements === 0 ? [] :
                        this.converter.deserializeArray(hvlpage.body.data, OrganizationDefinitionModel);

                    return new HvlPage<Array<OrganizationDefinitionModel>>(
                        data,
                        hvlpage.body.totalElements,
                        hvlpage.body.totalPages,
                        hvlpage.errorDetail,
                    );
                }),
            );
    }

    public queryPersonnelPage(pagination: PerPersonnelQueryModel): Observable<HvlPage<Array<PerPersonnelModel>>> {
        if (!pagination.pageable) {
            pagination.pageable = new HvlPageable();
        }

        const pattern = this.serviceRootPattern + 'personnelPage';
        return this.httpClient
            .post<HvlResponse<HvlPage<PerPersonnelModel[]>>>(this.endpoint + pattern, pagination)
            .pipe(
                map((hvlpage) => {
                    const data = hvlpage.body?.totalElements === 0 ? [] :
                        this.converter.deserializeArray(hvlpage.body.data, PerPersonnelModel);

                    return new HvlPage<Array<PerPersonnelModel>>(
                        data,
                        hvlpage.body.totalElements,
                        hvlpage.body.totalPages,
                        hvlpage.errorDetail,
                    );
                }),
            );
    }

    public queryPositionPage(pagination: PositionQueryModel): Observable<HvlPage<Array<PositionModel>>>  {
        if (!pagination.pageable) {
            pagination.pageable = new HvlPageable();
        }

        const pattern = this.serviceRootPattern + 'positionPage';
        return this.httpClient
            .post<HvlResponse<HvlPage<PositionModel[]>>>(this.endpoint + pattern, pagination)
            .pipe(
                map((hvlpage) => {
                    const data = hvlpage.body?.totalElements === 0 ? [] :
                        this.converter.deserializeArray(hvlpage.body.data, PositionModel);

                    return new HvlPage<Array<PositionModel>>(
                        data,
                        hvlpage.body.totalElements,
                        hvlpage.body.totalPages,
                        hvlpage.errorDetail,
                    );
                }),
            );
    }

    public searchPersonnelQueryList(queryModel: PerPersonnelSearchQueryModel): Observable<Array<PerPersonnelSearchModel>> {
        return this.httpClient
            .post<HvlResponse<Array<PerPersonnelSearchModel>>>(this.endpoint +this.serviceRootPattern + 'searchPersonnel', queryModel)
            .pipe(
                map((data) => {
                    const converter = new JsonConvert();
                    return converter.deserializeArray(data.body || [], PerPersonnelSearchModel);
                }),
            );
    }

}
